export type Lang = 'pl' | 'en';

type Entry = { pl: string; en: string };

const MESSAGES: Record<string, Entry> = {
  docTitle: {
    pl: 'Mesh Repair — domykanie plików STL do druku 3D',
    en: 'Mesh Repair — make STL files watertight for 3D printing',
  },
  subtitle: {
    pl: 'Naprawa siatki STL: scalanie wierzchołków, domykanie dziur i spójne normalne.',
    en: 'STL mesh repair: weld vertices, fill holes and fix normals.',
  },
  langTitle: { pl: 'Zmień język', en: 'Change language' },

  modelTitle: { pl: 'Model', en: 'Model' },
  modelTag: { pl: 'plik STL', en: 'STL file' },
  importBtn: { pl: 'Wybierz plik STL…', en: 'Choose an STL file…' },
  noModel: { pl: 'Wczytaj plik STL albo przeciągnij go na podgląd 3D.', en: 'Load an STL file or drop it onto the 3D view.' },
  fileLabel: { pl: 'Plik', en: 'File' },
  formatLabel: { pl: 'Format', en: 'Format' },
  fileSizeLabel: { pl: 'Rozmiar pliku', en: 'File size' },
  dimensionsLabel: { pl: 'Wymiary', en: 'Dimensions' },
  formatBinary: { pl: 'binarny', en: 'binary' },
  formatAscii: { pl: 'ASCII', en: 'ASCII' },

  statsTitle: { pl: 'Stan siatki', en: 'Mesh health' },
  statsTag: { pl: 'przed / po', en: 'before / after' },
  statsEmpty: { pl: 'Brak danych — wczytaj plik STL.', en: 'No data — load an STL file.' },
  colBefore: { pl: 'Przed', en: 'Before' },
  colAfter: { pl: 'Po', en: 'After' },
  rowTriangles: { pl: 'Trójkąty', en: 'Triangles' },
  rowVertices: { pl: 'Wierzchołki', en: 'Vertices' },
  rowEdges: { pl: 'Krawędzie', en: 'Edges' },
  rowOpen: { pl: 'Otwarte krawędzie', en: 'Open edges' },
  rowHoles: { pl: 'Dziury', en: 'Holes' },
  rowNonManifold: { pl: 'Nie-manifold', en: 'Non-manifold' },
  rowInconsistent: { pl: 'Niespójne normalne', en: 'Inconsistent normals' },
  rowDuplicates: { pl: 'Duplikaty trójkątów', en: 'Duplicate faces' },
  rowDegenerate: { pl: 'Zdegenerowane', en: 'Degenerate faces' },
  rowShells: { pl: 'Bryły (wyspy)', en: 'Shells' },
  rowVolume: { pl: 'Objętość', en: 'Volume' },
  rowArea: { pl: 'Powierzchnia', en: 'Surface area' },
  rowStatus: { pl: 'Status', en: 'Status' },
  statusWatertight: { pl: 'Wodoszczelna', en: 'Watertight' },
  statusClosedNonManifold: { pl: 'Zamknięta, ale nie-manifold', en: 'Closed, but non-manifold' },
  statusOpen: { pl: 'Nieszczelna', en: 'Not watertight' },
  statusEmpty: { pl: '—', en: '—' },
  legendOpen: { pl: 'otwarte krawędzie', en: 'open edges' },
  legendNonManifold: { pl: 'nie-manifold', en: 'non-manifold' },

  repairTitle: { pl: 'Naprawa', en: 'Repair' },
  repairTag: { pl: 'domykanie siatki', en: 'close the mesh' },
  toleranceLabel: { pl: 'Tolerancja scalania [mm]', en: 'Weld tolerance [mm]' },
  toleranceAuto: { pl: 'auto: {value} mm', en: 'auto: {value} mm' },
  toleranceHint: {
    pl: '0 = automatycznie. Większa wartość scala też bliskie, ale osobne wierzchołki.',
    en: '0 = automatic. A larger value also merges nearby but separate vertices.',
  },
  maxHoleLabel: { pl: 'Maks. dziura [krawędzie]', en: 'Max hole [edges]' },
  maxHoleHint: { pl: '0 = bez limitu. Mniejsze dziury są wypełniane.', en: '0 = no limit. Smaller holes are filled.' },
  optWeld: { pl: 'Scal wierzchołki', en: 'Weld vertices' },
  optDegenerate: { pl: 'Usuń zdegenerowane', en: 'Remove degenerate faces' },
  optDuplicates: { pl: 'Usuń duplikaty', en: 'Remove duplicate faces' },
  optWinding: { pl: 'Napraw normalne', en: 'Fix winding / normals' },
  optFill: { pl: 'Wypełnij dziury', en: 'Fill holes' },
  optLargest: { pl: 'Zostaw największą bryłę', en: 'Keep only the largest shell' },
  repairBtn: { pl: 'Napraw siatkę', en: 'Repair mesh' },
  repairRunAgain: { pl: 'Napraw ponownie', en: 'Repair again' },
  repairStatusOk: {
    pl: 'Gotowe — siatka jest wodoszczelna.',
    en: 'Done — the mesh is watertight.',
  },
  repairStatusRemaining: {
    pl: 'Uwaga: pozostało {open} otwartych krawędzi (dziur: {holes}). Zwiększ tolerancję albo limit dziur.',
    en: 'Warning: {open} open edges remain (holes: {holes}). Try a larger tolerance or hole limit.',
  },
  repairStatusNonManifold: {
    pl: 'Siatka jest zamknięta, ale ma {n} krawędzi nie-manifold.',
    en: 'The mesh is closed but has {n} non-manifold edges.',
  },
  repairStatusOther: {
    pl: 'Siatka jest zamknięta, ale nadal zawiera drobne problemy (np. duplikaty, zdegenerowane trójkąty lub normalne).',
    en: 'The mesh is closed but still has minor issues (e.g. duplicates, degenerate faces or normals).',
  },
  repairStatusStale: { pl: 'Ustawienia zmienione — kliknij „Napraw ponownie”.', en: 'Settings changed — click “Repair again”.' },
  reportTitle: { pl: 'Co zostało zrobione', en: 'What was done' },
  reportNothing: { pl: 'Siatka nie wymagała zmian.', en: 'The mesh needed no changes.' },
  reportWelded: { pl: 'scalonych wierzchołków', en: 'welded vertices' },
  reportDegenerate: { pl: 'usuniętych zdegenerowanych trójkątów', en: 'degenerate faces removed' },
  reportDuplicates: { pl: 'usuniętych duplikatów', en: 'duplicate faces removed' },
  reportWinding: { pl: 'odwróconych trójkątów (normalne)', en: 'flipped faces (normals)' },
  reportHoles: { pl: 'wypełnionych dziur', en: 'holes filled' },
  reportHoleTris: { pl: 'dodanych trójkątów w dziurach', en: 'triangles added in holes' },
  reportSkippedHoles: { pl: 'pominiętych dziur', en: 'holes skipped' },
  reportShells: { pl: 'usuniętych mniejszych brył', en: 'smaller shells removed' },
  reportTime: { pl: 'czas naprawy', en: 'repair time' },

  exportTitle: { pl: 'Eksport', en: 'Export' },
  exportTag: { pl: 'binarny STL', en: 'binary STL' },
  exportNameLabel: { pl: 'Nazwa pliku', en: 'File name' },
  downloadBtn: { pl: 'Pobierz naprawiony STL', en: 'Download repaired STL' },
  exportHint: {
    pl: 'Zapisuje zamkniętą siatkę jako binarny STL z przeliczonymi normalnymi. Jednostki pozostają w mm.',
    en: 'Saves the closed mesh as binary STL with recomputed normals. Units stay in mm.',
  },

  helpTitle: { pl: 'Jak to działa', en: 'How it works' },
  helpTag: { pl: 'kolejność operacji', en: 'pipeline' },
  helpText: {
    pl: '1. Scalenie wierzchołków (naprawa pęknięć). 2. Usunięcie zdegenerowanych i zdublowanych trójkątów. 3. Spójna orientacja normalnych (na zewnątrz). 4. Wypełnienie pętli brzegowych (dziur). 5. Eksport binarnego STL. Czerwone linie = otwarte krawędzie, różowe = nie-manifold.',
    en: '1. Weld vertices (close cracks). 2. Remove degenerate and duplicate faces. 3. Make normals consistent (outward). 4. Fill boundary loops (holes). 5. Export binary STL. Red lines = open edges, magenta = non-manifold.',
  },

  dropHint: { pl: 'Upuść plik STL tutaj', en: 'Drop an STL file here' },
  busyDefault: { pl: 'Przetwarzanie…', en: 'Processing…' },
  busyLoading: { pl: 'Wczytywanie i naprawa siatki…', en: 'Loading and repairing the mesh…' },
  busyRepairing: { pl: 'Naprawianie siatki…', en: 'Repairing the mesh…' },

  viewerOriginal: { pl: 'Oryginał', en: 'Original' },
  viewerRepaired: { pl: 'Naprawiony', en: 'Repaired' },
  viewerWireframe: { pl: 'Siatka', en: 'Wireframe' },
  viewerIssues: { pl: 'Problemy', en: 'Issues' },
  viewerHint: {
    pl: 'Podgląd 3D (przeciągnij = obrót, kółko = zoom, PPM = przesunięcie).',
    en: '3D preview (drag = rotate, wheel = zoom, right-drag = pan).',
  },
  badgeWatertight: { pl: 'Wodoszczelna', en: 'Watertight' },
  badgeNonManifold: { pl: 'Zamknięta • nie-manifold', en: 'Closed • non-manifold' },
  badgeOpen: { pl: 'Nieszczelna: {n} otwartych krawędzi', en: 'Open: {n} open edges' },

  alertChooseStl: { pl: 'Wybierz plik STL.', en: 'Please choose an STL file.' },
  alertLoadFailed: {
    pl: 'Nie udało się wczytać pliku STL. Sprawdź, czy plik nie jest uszkodzony.',
    en: 'Could not load the STL file. Check that the file is not corrupted.',
  },
  alertRepairFailed: { pl: 'Naprawa nie powiodła się:', en: 'Repair failed:' },
  unitMm: { pl: 'mm', en: 'mm' },
};

function detectLang(): Lang {
  const candidates: string[] = [];
  if (typeof navigator !== 'undefined') {
    if (navigator.languages && navigator.languages.length) candidates.push(...navigator.languages);
    if (navigator.language) candidates.push(navigator.language);
  }
  for (const tag of candidates) {
    const lang = tag.toLowerCase();
    if (lang.startsWith('pl')) return 'pl';
    if (lang.startsWith('en')) return 'en';
  }
  return 'en';
}

let current: Lang = detectLang();
const listeners: Array<() => void> = [];

export function getLang(): Lang {
  return current;
}

export function setLang(lang: Lang): void {
  if (lang === current) return;
  current = lang;
  for (const fn of listeners) fn();
}

export function onLangChange(fn: () => void): void {
  listeners.push(fn);
}

export function t(key: string, params?: Record<string, string | number>): string {
  const entry = MESSAGES[key];
  let text = entry ? entry[current] : key;
  if (params) {
    for (const [name, value] of Object.entries(params)) {
      text = text.split(`{${name}}`).join(String(value));
    }
  }
  return text;
}
